import { render, staticRenderFns } from "./AffiliatePage.vue?vue&type=template&id=328c64f9&"
import script from "./AffiliatePage.vue?vue&type=script&lang=js&"
export * from "./AffiliatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports